import { apiFetch } from '../../../lib/http';

// Portfolio (transcript) API. Not yet implemented on the backend. When it
// ships, flip USE_STUB in ../hooks/*.js to false and these calls run for real.
export const portfolioApi = {
  // The learner's own portfolio (self-view in /insights/portfolio).
  getLearnerPortfolio({ auth = true } = {}) {
    return apiFetch('/api/v1/users/portfolio', { method: 'GET', auth });
  },

  // A supervised student's portfolio (parent view in
  // /family/students/:id/portfolio). Same shape as the learner portfolio.
  getStudentPortfolio({ studentId, auth = true }) {
    return apiFetch(
      `/api/v1/parent/students/${encodeURIComponent(studentId)}/portfolio`,
      { method: 'GET', auth }
    );
  },
};
